module.exports = __webpack_public_path__ + "laserove-beleni-zubu_2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/special/laserove-beleni-zubu_2.jpg
// module id = 910
// module chunks = 0